import React, {useRef, useEffect, useState} from 'react';
import {useMapsLibrary} from '@vis.gl/react-google-maps';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { useField } from 'formik';
import { hasValue } from './inputHelpers.tsx';

interface Props {
  onPlaceSelect: (place: window.google.maps.places.PlaceResult | null) => void;
}
const XMapsInputReact = ({
  name,
  isHidden = false,
  helperText,
  onPlaceSelect,
  onMarkerSelected,
  onChange,
  value,
  setValue,
  InputLabelProps,
  margin = 'normal',
  ...props
}: TextFieldProps & IProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<window.google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  const [field, meta, helpers] = useField({ name });

  //const [value, setValue] = React.useState(field.value || ''); // Store the value in state


  React.useEffect(() => {
    if (field.value !== value) {
     setValue(field.value || '');
    }
  }, [field.value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    onChange(newValue);
    helpers.setValue(newValue); // Update Formik's field value
  };

  const error = hasValue(meta.error) ? meta.error : undefined;
  const showError = Boolean(error && meta.touched);

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      let p = placeAutocomplete.getPlace();
      onPlaceSelect(p);
      setValue(p.formatted_address);
      onMarkerSelected(p);
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <div className="autocomplete-container">
    <TextField
      {...field}
      {...props}
      margin={margin}
      fullWidth
      error={showError}
      helperText={(showError && error) || helperText }
      value={value}
      onChange={handleChange}
      inputRef={inputRef}
      autoComplete="nope"
      InputLabelProps={InputLabelProps}
    />     
    </div>
  );
};

export default XMapsInputReact;